import type { AnchorObjective, ObjectiveEdit } from './anchor_objective_types'

export const LOADING_ROW_WIDTHS = ['w-5/6', 'w-11/12', 'w-4/5']
export const LOADING_ROW_COUNT = 4

export function objectiveEdit(objectives: AnchorObjective[], index: number, text: string, isAllObjectives: boolean): ObjectiveEdit {
  const { level, title } = objectives[index]
  return { index, objective: { text, level, title }, isAllObjectives }
}
